import { render, staticRenderFns } from "./SalesStatisticsChart.vue?vue&type=template&id=2c2fbef2&"
import script from "./SalesStatisticsChart.vue?vue&type=script&lang=js&"
export * from "./SalesStatisticsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports